import {
  IconLayoutDashboard,
  IconBuilding,
  IconBed,
  IconCalendarEvent,
  IconReceipt2,
  IconMail,
  IconShieldLock,
} from "@tabler/icons";
import { UserType } from "store/constant";

const icons = {
  IconLayoutDashboard,
  IconBuilding,
  IconBed,
  IconCalendarEvent,
  IconReceipt2,
  IconMail,
  IconShieldLock,
};

export const getUtilities = () => {
  const userType = localStorage.getItem("userType");

  const adminMenu = [
    // =====================
    // DASHBOARD
    // =====================
    {
      id: "dashboard",
      title: "Dashboard",
      type: "group",
      children: [
        {
          id: "dashboard-home",
          title: "Dashboard",
          type: "item",
          url: "/dashboard",
          icon: icons.IconLayoutDashboard,
        },
      ],
    },

    // =====================
    // CAFE MANAGEMENT
    // =====================
    {
      id: "management",
      title: "Management",
      type: "group",
      children: [
        {
          id: "cafes",
          title: "Cafes",
          type: "item",
          url: "/cafe",
          icon: icons.IconBuilding,
        },
        {
          id: "kyc",
          title: "KYC Details",
          type: "item",
          url: "/kyc",
          icon: icons.IconReceipt2,
        },
        {
          id: "investments",
          title: "Investments",
          type: "item",
          url: "/investment",
          icon: icons.IconCalendarEvent,
        },
        {
          id: "referral-earnings",
          title: "Referral Earnings",
          type: "item",
          url: "/referral",
          icon: icons.IconReceipt2,
        },
        {
          id: "users",
          title: "Users",
          type: "item",
          url: "/users",
          icon: icons.IconLayoutDashboard,
        },
        {
          id: "contacts",
          title: "Contacts",
          type: "item",
          url: "/contacts",
          icon: icons.IconMail,
        },
        {
          id: "roles",
          title: "Roles",
          type: "item",
          url: "/roles",
          icon: icons.IconReceipt2,
        },
        {
          id: "role-assignment",
          title: "Permissions",
          type: "item",
          url: "/roles/assignment",
          icon: icons.IconShieldLock,
        },
        // {
        //   id: "profit-distribution",
        //   title: "Profit Distribution",
        //   type: "item",
        //   url: "/profit-distribution",
        //   icon: icons.IconReceipt2,
        // },
        // {
        //   id: "shares",
        //   title: "Shares",
        //   type: "item",
        //   url: "/shares",
        //   icon: icons.IconBed,
        // },
      ],
    },
  ];

  if (userType === UserType.Admin) return adminMenu;

  return [];
};
